import React, { useContext, useMemo, useState } from 'react';
import { NutritionAllergenComponent } from 'organisms/NutritionAllergenLandingPage/AU';
import { LOCAL_STORAGE_KEYS, NUTRITION_ALLERGEN } from 'common/constants/SharedConstants';
import { getDispositionTypeOnAPIFormat, isEmptyObject } from 'common/utilities/utils';
import { UserOrderContext } from 'context/context';
import { BannerData } from 'organisms/BannerComponent';
import ScrollTop from 'molecules/ScrollTop';
import { StructureData } from 'organisms/StructureDataComponent';
import { useSelector } from 'react-redux';

const NutritionAllergenLandingPage = props => {
  const { userOrderState } = useContext(UserOrderContext);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const [showTopScrollBtn, setShowTopScrollBtn] = useState(true);
  const dispositionNew = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW));
  /* istanbul ignore next */
  const params = useMemo(() => {
    return {
      tenantReducer: isEmptyObject(tenantReducer)
        ? tenantReducer
        : JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.TENANT_REDUCER)),
      storeInfo: dispositionNew ? dispositionNew.store : {},
      selectedTile:
        userOrderState && isEmptyObject(userOrderState.selectedTile)
          ? userOrderState.selectedTile
          : JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.SELECTED_TILE)),
      dispositionType: dispositionNew?.type
        ? getDispositionTypeOnAPIFormat(dispositionNew.type)
        : getDispositionTypeOnAPIFormat(tenantReducer.authoredContent?.defaultdisposition),
    };
  }, [dispositionNew, userOrderState, tenantReducer]);

  return (
    <React.Fragment>
      <BannerData />
      <StructureData page={NUTRITION_ALLERGEN} />
      <NutritionAllergenComponent
        setShowTopScrollBtn={setShowTopScrollBtn}
        contentData={params}
        selectedCat={props?.location?.selectedCat}
        history={props.history}
      />
      {showTopScrollBtn && <ScrollTop showThreshold={500} />}
    </React.Fragment>
  );
};

export default NutritionAllergenLandingPage;
